export default "__VITE_ASSET__BAjf7gDJ__"